//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from "swiper";
export default {
  name: "index",
  data() {
    return {
      idx: 0,
      stu: 0,
      new_text: "",
      about_img: "",
      detail: {},
      about_detail: "",
      banner: [],
      project_list: [],
      project: [],
      nav: [
        {
          text: "首页",
          status: "0",
        },
        {
          text: "关于中启",
          status: "1",
        },
        {
          text: "工程案例",
          status: "2",
        },
        {
          text: "新闻中心",
          status: "3",
        },
        {
          text: "业务中心",
          status: "4",
        },
        {
          text: "人力资源",
          status: "5",
        },
        {
          text: "联系我们",
          status: "6",
        },
      ],
      business_list2: [],
      business_list3: [],
      business_list1: [],
      new_list: [],
    };
  },
  methods: {
    //鼠标移入
    enter1(a) {
      const _this = this;
      _this.business_list2[a].status = 1;
    },
    enter2(a) {
      const _this = this;
      _this.business_list1[a].status = 1;
    },
    enter3(a) {
      const _this = this;
      _this.business_list3[a].status = 1;
    },
    enter4(a) {
      var id = a;
      document.getElementById(id).style.display = "block";
    },
    //鼠标移出
    leave1(a) {
      const _this = this;
      _this.business_list2[a].status = 0;
    },
    leave2(a) {
      const _this = this;
      _this.business_list1[a].status = 0;
    },
    leave3(a) {
      const _this = this;
      _this.business_list3[a].status = 0;
    },
    leave4(a) {
      var id = a;
      document.getElementById(id).style.display = "none";
    },
    //工程案例tab
    project_click(a) {
      const _this = this;
      _this.project_list = [];
      var list = [];
      this.stu = a;
      if (_this.project[a].projectlist.length > 8) {
        for (let i = 0; i < 8; i++) {
          _this.project_list.push(_this.project[a].projectlist[i]);
        }
      } else {
        _this.project_list = _this.project[a].projectlist;
      }
    },
    collect_click() {
      alert("请按住Ctrl+D收藏网站");
    },
    //导航跳转
    rout(a) {
      if (a == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (a == 1) {
        this.$router.push({
          path: "/about",
        });
      } else if (a == 2) {
        this.$router.push({
          path: "/project",
        });
      } else if (a == 3) {
        this.$router.push({
          path: "/new",
        });
      } else if (a == 4) {
        this.$router.push({
          path: "/business",
        });
      } else if (a == 5) {
        this.$router.push({
          path: "/recruit",
        });
      } else if (a == 6) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    //跳转到新闻详情页面
    new_detai(a) {
      this.$router.push({
        path: "/newdetails",
        query: {
          id: a,
        },
      });
    },
    newswiper() {},
    details() {
      const _this = this;
      let Base64 = require("js-base64").Base64;
      _this.$get("/header/home/fetch").then((res) => {
        _this.banner = res.data.bannerList;
        _this.new_text = res.data.newsList.list[0].title;
        _this.about_img = res.data.aboutUsVo.mainImage;
        _this.new_list = res.data.newsList.list;
        _this.detail = res.data;
        _this.about_detail = Base64.decode(res.data.aboutUsVo.content);
        _this.project = res.data.projectAllVos;
        if (res.data.projectAllVos[0].projectlist.length > 8) {
          for (let i = 0; i < 8; i++) {
            _this.project_list.push(res.data.projectAllVos[0].projectlist[i]);
          }
        } else {
          _this.project_list = res.data.projectAllVos[0].projectlist;
        }
        for (let i = 0; i < res.data.businessList.length; i++) {
          if (i == 0) {
            _this.business_list2.push(res.data.businessList[i]);
          } else if (i > 0 && i < 5) {
            _this.business_list1.push(res.data.businessList[i]);
          } else {
            _this.business_list3.push(res.data.businessList[i]);
          }
        }
      });
    },
  },
  updated() {
    new Swiper(".swiper1", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    new Swiper(".swiper2", {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
        el: ".page2",
        clickable: true,
      },
      navigation: {
        nextEl: ".next2",
        prevEl: ".prev2",
      },
    });
    new Swiper(".new_swiper", {
      centeredSlides: true,
      mousewheel: true,
      pagination: {
        el: ".new_page",
        clickable: true,
      },
    });
  },
  mounted() {
    const _this = this;
    _this.details();
  },
};



// WEBPACK FOOTER //
// ./src/components/index.vue